import { createContext, useContext } from "react";

export const TableVariantContext = createContext("classic");

export const useTableVariant = () => useContext(TableVariantContext);
